// @ts-check
import axios from 'axios'

const BASE = '/api/work/telehealth/address-book'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['AddressBookEntry']} AddressBookEntry */
/** @typedef {Schemas['AddressBookEntryCreateRequest']} AddressBookEntryCreateRequest */
/** @typedef {Schemas['PatchedAddressBookEntryUpdateRequest']} AddressBookEntryUpdateRequest */
/** @typedef {import('./schema').operations['telehealth_address_book_list']['parameters']['query']} AddressBookListQuery */

/**
 * GET /api/work/telehealth/address-book/ — address book entries for the current tenant.
 * @param {AddressBookListQuery} [params]
 * @returns {Promise<AddressBookEntry[]>}
 */
export async function listAddressBookEntries(params) {
  const { data } = await axios.get(`${BASE}/`, { params })
  return data
}

/**
 * POST /api/work/telehealth/address-book/ — create an address book entry (admin/security only).
 * @param {AddressBookEntryCreateRequest} body
 * @returns {Promise<AddressBookEntry>}
 */
export async function createAddressBookEntry(body) {
  const { data } = await axios.post(`${BASE}/`, body)
  return data
}

/**
 * PATCH /api/work/telehealth/address-book/{entryId}/ — update or deactivate (is_active=false) an entry (admin only).
 * @param {number} entryId
 * @param {AddressBookEntryUpdateRequest} body
 * @returns {Promise<AddressBookEntry>}
 */
export async function updateAddressBookEntry(entryId, body) {
  const { data } = await axios.patch(`${BASE}/${entryId}/`, body)
  return data
}
